import OptionSearchAdvanced from "../../components/organisms/OptionSearchAdvanced";

function SearchAdvanced() {
  return <OptionSearchAdvanced />;
}
export default SearchAdvanced;